export default __webpack_public_path__ + "static/media/bx-dollar-green.c3bef194.svg";